import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { emailValidationSchema } from "../../validation/emailSchema";
import prodigy from "../../Assets/brand/ProdiogyIcon.svg";

const EmailVerification: React.FC = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: emailValidationSchema,
    onSubmit: async (values) => {
      setIsSubmitting(true);
      try {
        // Navigate to OTP verification page
        navigate("/first-verify", { state: { email: values.email } });
      } catch (error) {
        console.error("Error submitting email:", error);
      } finally {
        setIsSubmitting(false);
      }
    },
  });

  return (
    <div
      id="email-verification-container"
      className="w-full max-w-md h-full flex flex-col"
    >
      <div
        id="email-verification-content"
        className="flex-1 flex flex-col justify-center"
      >
        <img
          id="email-verification-logo"
          src={prodigy}
          alt="Prodigy Health"
          className="w-32 md:w-40 mb-8"
        />

        <h2
          id="email-verification-heading"
          className="text-[18px] font-medium text-[#080F1A] font-outfit leading-[120%] mb-2"
        >
          Welcome to Carepro
        </h2>

        <p
          id="email-verification-description"
          className="text-[14px] font-normal text-[#647491] font-outfit leading-[150%] mb-8"
        >
          We'll send you a 6-digit verification code to this email
        </p>

        <form
          id="email-verification-form"
          onSubmit={formik.handleSubmit}
          className="flex flex-col"
        >
          <div
            id="email-verification-email-container"
            className="flex flex-col mb-6"
          >
            <label htmlFor="email-verification-email-input" className="sr-only">
              Email address
            </label>
            <input
              id="email-verification-email-input"
              type="text"
              placeholder="Email address"
              {...formik.getFieldProps("email")}
              className={`w-full rounded-lg border px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#0566FF] focus:border-transparent ${
                formik.touched.email && formik.errors.email
                  ? "border-red-300"
                  : "border-gray-300"
              }`}
              aria-label="Email address"
              aria-required="true"
              aria-invalid={formik.touched.email && !!formik.errors.email}
              aria-describedby={
                formik.touched.email && formik.errors.email
                  ? "email-verification-email-error"
                  : undefined
              }
            />
            {formik.touched.email && formik.errors.email && (
              <div
                id="email-verification-email-error"
                className="mt-1 text-xs text-[#F94839] font-normal font-outfit"
                role="alert"
              >
                {formik.errors.email}
              </div>
            )}
          </div>

          <button
            id="email-verification-submit-button"
            type="submit"
            disabled={
              !formik.values.email.trim() || !formik.isValid || isSubmitting
            }
            className="w-full bg-[#A9C3FF] hover:bg-[#0566FF] text-white text-center text-[14px] font-medium font-outfit leading-[150%] py-3 rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-[#0566FF] focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
            aria-label="Continue to verification"
          >
            {isSubmitting ? "Sending..." : "Continue"}
          </button>
        </form>
      </div>

      <p
        id="email-verification-footer"
        className="mt-auto mb-10 text-xs text-[#647491]"
      >
        © 2025 Arete Healthtech Pvt. Ltd. All rights reserved.
      </p>
    </div>
  );
};

export default EmailVerification;
